import { render } from "./ConfirmationLayout.vue?vue&type=template&id=417c8a0a"
import script from "./ConfirmationLayout.vue?vue&type=script&lang=js"
export * from "./ConfirmationLayout.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Efren Bustos\\source\\repos\\VDAI\\vdai\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__